export const productCategories = [
  {
    id: "bifold-doors",
    name: "Aluminium Bifold Doors",
    tagline: "Seamless Indoor-Outdoor Living",
    description: "Transform your home with our stunning aluminium bifold doors. Engineered for maximum glass area and minimal sightlines, our bifold doors create a spectacular connection between your interior and garden. Available in a wide range of RAL colours and configurations to suit any property style.",
    features: [
      "Ultra-slim sightlines for maximum light",
      "Multi-point locking system",
      "Thermally broken aluminium frames",
      "Customisable panel configurations",
      "10-year structural guarantee",
      "A-rated energy efficiency",
    ],
    image: "https://public.readdy.ai/ai/img_res/c764aadb1239cb5882f372298e158fc5.jpg",
    slug: "bifold-doors",
  },
  {
    id: "upvc-windows",
    name: "uPVC Windows",
    tagline: "Energy Efficient & Low Maintenance",
    description: "Our premium uPVC windows combine outstanding energy efficiency with classic style. Available in casement, tilt & turn, sash, and bay configurations, they provide superior insulation, noise reduction, and security. Virtually maintenance-free with a lifespan of 30+ years.",
    features: [
      "Double or triple glazing options",
      "A++ energy rating available",
      "Multi-point locking as standard",
      "Wide colour range including woodgrain",
      "Easy-clean glass options",
      "30+ year lifespan",
    ],
    image: "https://readdy.ai/api/search-image?query=modern%20white%20uPVC%20casement%20windows%20installed%20elegant%20uk%20residential%20property%20exterior%20natural%20daylight%20energy%20efficient%20clean%20contemporary%20home%20facade&width=700&height=500&seq=prod2&orientation=landscape",
    slug: "upvc-windows",
  },
  {
    id: "aluminium-windows",
    name: "Aluminium Windows",
    tagline: "Slim Profiles, Maximum Light",
    description: "Our aluminium windows offer the ultimate in slim-frame design, allowing you to maximise natural light and enjoy unobstructed views. Perfect for both contemporary new builds and period renovations, with thermally broken frames providing excellent insulation performance.",
    features: [
      "Slimmer sightlines than uPVC",
      "Thermally broken for insulation",
      "Available in any RAL colour",
      "Flush casement options",
      "Corrosion-resistant frames",
      "Ideal for large apertures",
    ],
    image: "https://readdy.ai/api/search-image?query=slim%20frame%20aluminium%20windows%20large%20glass%20panels%20contemporary%20modern%20uk%20home%20exterior%20architectural%20elegant%20natural%20light%20interior%20view&width=700&height=500&seq=prod3&orientation=landscape",
    slug: "aluminium-windows",
  },
  {
    id: "composite-doors",
    name: "Composite Doors",
    tagline: "Secure, Stylish & Durable",
    description: "Make a lasting first impression with our premium composite doors. Combining the warmth of timber aesthetics with the durability of modern composites, these doors provide unbeatable security, thermal performance, and kerb appeal. Available in hundreds of styles and colour combinations.",
    features: [
      "Solid timber core construction",
      "Secured by Design accredited",
      "A-rated thermal performance",
      "Anti-bump, anti-pick cylinders",
      "Wide range of glass designs",
      "Matching hardware finishes",
    ],
    image: "https://readdy.ai/api/search-image?query=elegant%20premium%20composite%20door%20dark%20anthracite%20grey%20entrance%20door%20modern%20uk%20residential%20house%20front%20door%20stylish%20secure%20quality%20craftsmanship&width=700&height=500&seq=prod4&orientation=landscape",
    slug: "composite-doors",
  },
  {
    id: "conservatories",
    name: "Conservatories",
    tagline: "Extend Your Living Space",
    description: "A beautifully designed conservatory adds valuable living space and enhances the natural light in your home. We offer a full range of conservatory styles from traditional Victorian to contemporary lean-to designs, all built with the highest quality materials and expert craftsmanship.",
    features: [
      "Victorian, Edwardian, P-shape, Lean-to",
      "Solid tiled or glass roof options",
      "Fully insulated for year-round use",
      "Integrated blinds available",
      "Matching base walls",
      "Planning and build service",
    ],
    image: "https://readdy.ai/api/search-image?query=beautiful%20white%20conservatory%20extension%20traditional%20uk%20home%20garden%20bright%20interior%20plants%20sunlight%20elegant%20glass%20roof%20comfortable%20living%20space%20extension&width=700&height=500&seq=prod5&orientation=landscape",
    slug: "conservatories",
  },
  {
    id: "roof-lanterns",
    name: "Roof Lanterns",
    tagline: "Flood Your Home with Light",
    description: "Our aluminium roof lanterns are architectural showpieces that transform flat or low-pitch roofs into dramatic, light-filled spaces. Whether fitted to an extension, orangery, or kitchen, a roof lantern creates a stunning focal point while flooding your room with natural light.",
    features: [
      "Slim aluminium glazing bars",
      "Self-cleaning glass option",
      "Walk-on versions available",
      "Multiple size configurations",
      "Integrated thermal performance",
      "Made to measure service",
    ],
    image: "https://readdy.ai/api/search-image?query=stunning%20aluminium%20roof%20lantern%20skylight%20modern%20kitchen%20extension%20natural%20light%20flooding%20in%20contemporary%20uk%20home%20interior%20bright%20airy%20architectural&width=700&height=500&seq=prod6&orientation=landscape",
    slug: "roof-lanterns",
  },
  {
    id: "french-doors",
    name: "French Doors",
    tagline: "Timeless Elegance, Modern Security",
    description: "Our French doors bring a touch of timeless elegance to any home. Available in both uPVC and aluminium, they provide a classic way to connect your living space to your garden while offering modern security and weather resistance.",
    features: [
      "Available in uPVC and aluminium",
      "Outward or inward opening",
      "Decorative glass options",
      "Multi-point locking",
      "Low threshold options",
      "Side light panels available",
    ],
    image: "https://readdy.ai/api/search-image?query=elegant%20french%20doors%20open%20garden%20summer%20uk%20home%20white%20aluminium%20frame%20clear%20glass%20patio%20contemporary%20classic%20style%20residential%20property&width=700&height=500&seq=prod7&orientation=landscape",
    slug: "french-doors",
  },
  {
    id: "patio-doors",
    name: "Patio Sliding Doors",
    tagline: "Space-Saving Garden Access",
    description: "Our smooth-gliding patio doors are perfect where space is at a premium. Offering large glass areas for maximum views and light, they slide effortlessly on precision-engineered rollers. Available in 2, 3, or 4 panel configurations.",
    features: [
      "Smooth precision-engineered rollers",
      "Lift and slide mechanism",
      "Anti-lift security bolts",
      "2, 3, or 4 panel options",
      "Low threshold for easy access",
      "Available in uPVC and aluminium",
    ],
    image: "https://readdy.ai/api/search-image?query=modern%20patio%20sliding%20doors%20large%20glass%20panels%20contemporary%20uk%20home%20garden%20view%20interior%20natural%20light%20open%20space%20living%20room%20aluminium&width=700&height=500&seq=prod8&orientation=landscape",
    slug: "patio-doors",
  },
];
